import { Banner } from '~/components/Layout/Banner'
import { useActiveOrg, useResetActiveOrg } from '~/hooks/org'

export const ViewAsBanner = () => {
  const { org } = useActiveOrg()
  const resetActiveOrg = useResetActiveOrg()

  return (
    <Banner>
      <span className="text-sm font-medium text-white">
        Viewing as {org?.name}
      </span>
      <button
        type="button"
        onClick={resetActiveOrg}
        className="rounded-md px-2 py-0.5 text-sm font-medium text-white/75 hover:bg-white/15 hover:text-white"
      >
        Exit
      </button>
    </Banner>
  )
}
